import {
  SHOW_QUESTION_DETAILS,
  HIDE_QUESTION_DETAILS, // UPDATE_QUESTION_DETAILS
} from './actionTypes';

export const showQuestionDetailsAction = ({ questionId, action, source }) => ({
  type: SHOW_QUESTION_DETAILS,
  data: {
    questionId,
    action,
    source,
  },
});

// export const updateQuestionDetailsAction = ({ questionId, action, source }) => ({
//   type: UPDATE_QUESTION_DETAILS,
//   data: {
//     questionId,
//     action,
//     source
//   }
// });

export const hideQuestionDetailsAction = ({ updatedQuestion }) => ({
  type: HIDE_QUESTION_DETAILS,
  data: {
    updatedQuestion,
  },
});
